import React from "react";
import { Table } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { formatNumberOnDashBoard } from "../../../helper";
import Pagination from "../../Pagination";
import { projectScheme } from "../../../actions/mis.action";
import { get } from "lodash";
import NoDataFound from "../../../component/NoDataFound";
import { isValidArray } from "../../../helper";

class MinistryReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      limit: 10
    };
  }
  onPageChange = pageNumber => {
    const { limit, offset } = this.state;
    let data = {
      limit: limit,
      offset: offset
    };
    this.setState(
      { offset: pageNumber.selected, ...pageNumber },
      this.props.projectScheme(data)
    );
  };
  render() {
    const { misData } = this.props;
    const { limit, offset } = this.state;
    return (
      <div>
        <Table striped size="sm" className="mis-project-list table-striped">
          <thead>
            <tr>
              <th className="ministry-name-column">Ministry Name</th>
              <th className="ministry-projects-column">Number of Projects</th>
              <th className="ministry-cost-column">Cost(cr)</th>
            </tr>
          </thead>
          <tbody>
            {isValidArray(get(misData, "data")) ? (
              <>
                {misData &&
                  misData.data &&
                  misData.data.map((data, index) => {
                    return (
                      <tr key={index}>
                        <td className="ministry-name-column">{data.name}</td>
                        <td className="ministry-projects-column">
                          {data.number}
                        </td>
                        <td className="ministry-cost-column">
                          {(data.cost &&
                            `${formatNumberOnDashBoard(data.cost)}`) ||
                            "NA"}{" "}
                        </td>
                      </tr>
                    );
                  })}
              </>
            ) : (
              <tr>
                <td colSpan="7">
                  <NoDataFound />
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      projectScheme: projectScheme
    },
    dispatch
  );
}

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(MinistryReport)
);
